// KAS Rewards Page JavaScript (external asset)

// Global configuration - check if already declared to avoid conflicts
if (typeof SHOP_DOMAIN === 'undefined') {
    var SHOP_DOMAIN = 'kas-australia.myshopify.com';
}
if (typeof LOYALTY_ENDPOINT === 'undefined') {
    var LOYALTY_ENDPOINT = 'https://kas-cin7-shopify-sync.jackieochan.workers.dev/kas/points.php';
}
if (typeof LOYALTY_DETAILS_ENDPOINT === 'undefined') {
    var LOYALTY_DETAILS_ENDPOINT = 'https://kas-cin7-shopify-sync.jackieochan.workers.dev/kas/customer.php';
}
/** True only when Shopify has a live customer session (not localStorage "remembered" guest). */
function kasIsShopifyCustomerLoggedIn() {
    if (typeof window.kasShopifyCustomerLoggedIn === 'boolean') {
        return window.kasShopifyCustomerLoggedIn;
    }
    return !!(window.customer && window.customer.id);
}

/**
 * Influence.io may send a handle (e.g. "kasaustralia") instead of a full URL; relative values
 * resolve on the shop domain and break window.open. Normalize to absolute profile URLs.
 */
function kasNormalizeSocialVisitUrl(platform, rawUrl, defaultUrl) {
    var raw = (rawUrl && String(rawUrl).trim()) || '';
    if (!raw) return defaultUrl || '';
    if (/^\/\//.test(raw)) return 'https:' + raw;
    if (/^https?:\/\//i.test(raw)) return raw;
    var segment = raw.replace(/^@/, '').replace(/^\/+|\/+$/g, '');
    if (!segment) return defaultUrl || '';
    if (platform === 'instagram') {
        if (/instagram\.com/i.test(segment)) {
            var rest = segment.replace(/^https?:\/\//i, '').replace(/^www\./i, '');
            return 'https://www.' + rest;
        }
        return 'https://www.instagram.com/' + segment;
    }
    if (platform === 'facebook') {
        if (/facebook\.com/i.test(segment)) {
            var frest = segment.replace(/^https?:\/\//i, '').replace(/^www\./i, '');
            return 'https://www.' + frest;
        }
        return 'https://www.facebook.com/' + segment;
    }
    return defaultUrl || raw;
}

document.addEventListener('DOMContentLoaded', function() {
    if (window.__KAS_REWARDS_DOM_INIT_DONE) {
        return;
    }
    window.__KAS_REWARDS_DOM_INIT_DONE = true;

    // Hook up rewards banner + drawer
    initRewardsBanner();
    // Fetch and display shop rules from Influence.io
    fetchShopRules();
    fetchRedeemRules();
    fetchLoyaltyTiers();
    // Initialize customer tier status
    initCustomerTierStatus();
    // Initialize product points display
    initProductPointsDisplay();

    if (typeof updateCartDrawerEarnPoints === 'function') {
        updateCartDrawerEarnPoints();
    }
    
    // Fetch customer loyalty details to get currentLoyaltyTierId
    if (window.customer?.id) {
        fetchCustomerLoyaltyDetails().then(function(loyaltyDetails) {
            if (loyaltyDetails && loyaltyDetails.currentLoyaltyTierId) {
                // Update the customer object with the tier ID
                window.customer.currentLoyaltyTierId = loyaltyDetails.currentLoyaltyTierId;
                
                // Re-calculate product points with the correct tier ID
                const productHelpers = document.querySelectorAll('.swell-product-helper[data-mode="display-points"]');
                productHelpers.forEach(function(helper) {
                    updateProductPoints(helper);
                });

                if (typeof updateCartDrawerEarnPoints === 'function') {
                    updateCartDrawerEarnPoints();
                }
                
                // Update customer points balance for redeem progress calculation
                if (loyaltyDetails.pointBalance !== undefined) {
                    window.customer.pointBalance = loyaltyDetails.pointBalance;
                    
                    // CRITICAL: Update the banner with the new points value
                    if (window.KASRewards && typeof window.KASRewards.updateBannerPoints === 'function') {
                        window.KASRewards.updateBannerPoints(loyaltyDetails.pointBalance);
                    }
                    
                    // CRITICAL: Update points UI and re-render redeem list if rules are already loaded
                    if (window.KASRewards && typeof window.KASRewards.updatePoints === 'function') {
                        window.KASRewards.updatePoints(loyaltyDetails.pointBalance);
                    } else {
                        // Fallback: manually trigger update
                        const redeemListContainer = document.querySelector('[data-kas-redeem-list]');
                        if (redeemListContainer && window.__kasRedeemRules) {
                            renderRedeemList(redeemListContainer, window.__kasRedeemRules);
                        }
                    }
                }
            }
        }).catch(function(error) {
        });
    }

    // Smooth scrolling for any anchor links
    const links = document.querySelectorAll('a[href^="#"]');
    links.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });

    // Fetch shop rules from DataJet endpoint
    async function fetchShopRules() {
        try {
            const API_ENDPOINT = `https://launcher.api.influence.io/launcher/v1/shop/rules/earn?shop=${SHOP_DOMAIN}`;

            const response = await fetch(API_ENDPOINT, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            
            // Handle Influence.io API response structure: data.rules
            if (data && data.rules) {
                displayEarnRules(data.rules);
            } else {
                console.error('Unexpected response structure:', data);
                displayFallbackRules();
            }
        } catch (error) {
            // Error fetching shop rules - non-critical
            // Display fallback content if API fails
            displayFallbackRules();
        }
    }

    // Fetch redeem rules from DataJet endpoint
    async function fetchRedeemRules() {
        try {
            const API_ENDPOINT = `https://launcher.api.influence.io/launcher/v1/shop/rules/redeem?shop=${SHOP_DOMAIN}`;

            const response = await fetch(API_ENDPOINT, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            
            // Handle Influence.io API response structure: data.rules
            if (data && data.rules) {
                // Store redeem rules globally for later use
                window.__kasRedeemRules = data.rules;
                updateRedeemProgress(data.rules);
                if (typeof displayAmountDiscountTiles === 'function') {
                    displayAmountDiscountTiles(data.rules);
                }
                // Update the redeem list display
                const redeemListContainer = document.querySelector('[data-kas-redeem-list]');
                if (redeemListContainer) {
                    renderRedeemList(redeemListContainer, data.rules);
                    
                    // If points are already loaded, re-render the list to update availability
                    if (window.customer?.pointBalance !== null && window.customer?.pointBalance !== undefined) {
                        // Small delay to ensure DOM is ready
                        setTimeout(() => {
                            renderRedeemList(redeemListContainer, data.rules);
                        }, 100);
                    }
                }
            } else {
                console.error('Unexpected redeem rules response structure:', data);
            }
        } catch (error) {
            console.error('Error fetching redeem rules:', error);
        }
    }


    // CDN base for campaign tile icons (matches existing Liquid assets)
    var KAS_EARN_ICON_BASE = 'https://cdn.shopify.com/s/files/1/0993/1130/files/';
    var KAS_EARN_ICONS = {
        placeorder: 'image_2022_09_22_03_12_01_196.png?v=1759220201',
        signup: 'image_2024_04_11_09_36_06_678.png?v=1759220541',
        followinstagram: 'image_2022_09_22_03_15_09_597.png?v=1759220941',
        sharefacebook: 'image_2022_09_22_03_14_47_780.png?v=1759220872',
        birthday: 'image_2022_10_11_03_19_34_965.png?v=1759220977',
        dynamiclink: 'image_2022_09_22_03_14_21_232.png?v=1759220835',
        dynamiclink_pinterest: 'image_2022_09_22_03_12_42_433.png?v=1759220657',
        reviewsio: 'image_2023_01_13_01_51_21_002.png?v=1759220695',
        reviewsio_ugc: 'image_2023_01_13_01_51_39_685.png?v=1759220751'
    };

    function getEarnRuleIconUrl(rule) {
        if (rule.templateName === 'reviewsio' && rule.integrationEventName === 'reviewsio_product_ugc') {
            return KAS_EARN_ICON_BASE + KAS_EARN_ICONS.reviewsio_ugc;
        }
        if (rule.templateName === 'dynamiclink' && rule.customTitle && rule.customTitle.toLowerCase().indexOf('pinterest') !== -1) {
            return KAS_EARN_ICON_BASE + KAS_EARN_ICONS.dynamiclink_pinterest;
        }
        var key = rule.templateName in KAS_EARN_ICONS ? rule.templateName : 'dynamiclink';
        return KAS_EARN_ICON_BASE + (KAS_EARN_ICONS[key] || KAS_EARN_ICONS.dynamiclink);
    }

    function getEarnRuleSortOrder(rule) {
        var order = { placeorder: 0, signup: 1, dynamiclink: 2, followinstagram: 3, sharefacebook: 4, reviewsio: 5, birthday: 6 };
        var base = order[rule.templateName] !== undefined ? order[rule.templateName] : 7;
        if (rule.templateName === 'dynamiclink') {
            return base + (rule.customTitle && rule.customTitle.toLowerCase().indexOf('sms') !== -1 ? 0 : 1);
        }
        if (rule.templateName === 'reviewsio') {
            var ev = rule.integrationEventName || '';
            if (ev.indexOf('ugc') !== -1) return 8;
            if (ev.indexOf('company') !== -1) return 7;
            return 6;
        }
        return base;
    }

    function escapeHtml(text) {
        if (!text) return '';
        var div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    // Display the fetched earning rules (Ways to Earn Style Points) from Influence.io API
    function displayEarnRules(rules) {
        const earnGrid = document.querySelector('.earn-grid');
        if (!earnGrid) {
            // Still store rules for point calculations
        }

        if (earnGrid) {
            earnGrid.innerHTML = '';
        }

        window.__kasEarnRules = rules;

        if (typeof updateProductPoints === 'function') {
            const productHelpers = document.querySelectorAll('.swell-product-helper[data-mode="display-points"]');
            productHelpers.forEach(function(helper) {
                updateProductPoints(helper);
            });
        }

        if (typeof updateCartDrawerEarnPoints === 'function') {
            updateCartDrawerEarnPoints();
        }

        var active = (rules || []).filter(function(r) { return r.status === 'Active'; });

        var toShow = [];
        var hasPlaceorder = false;
        active.forEach(function(rule) {
            if (rule.templateName === 'placeorder') {
                if (!hasPlaceorder) {
                    hasPlaceorder = true;
                    toShow.push(rule);
                } else {
                    var existing = toShow.find(function(r) { return r.templateName === 'placeorder'; });
                    if (rule.earnValue < existing.earnValue) {
                        toShow[toShow.indexOf(existing)] = rule;
                    }
                }
            } else {
                toShow.push(rule);
            }
        });

        toShow.sort(function(a, b) {
            return getEarnRuleSortOrder(a) - getEarnRuleSortOrder(b);
        });

        var isLoggedIn = kasIsShopifyCustomerLoggedIn();

        toShow.forEach(function(rule) {
            var title = rule.customTitle || rule.title;
            var pointsLabel = '';
            var description = title;

            if (rule.earnType === 'increments') {
                pointsLabel = rule.earnValue + ' Points Per $';
                description = 'Make a purchase';
            } else {
                pointsLabel = rule.earnValue + ' points';
                if (rule.templateName === 'signup') {
                    description = 'Create an Account';
                } else if (rule.templateName === 'birthday') {
                    description = 'Birthday Reward';
                } else if (rule.customTitle) {
                    description = rule.customTitle;
                }
            }

            var iconUrl = getEarnRuleIconUrl(rule);
            var socialPlatform = null;
            var socialUrl = '';
            if (rule.templateName === 'followinstagram') {
                socialPlatform = 'instagram';
                socialUrl = kasNormalizeSocialVisitUrl('instagram', rule.socialUrl, 'https://www.instagram.com/kasaustralia');
            } else if (rule.templateName === 'sharefacebook') {
                socialPlatform = 'facebook';
                socialUrl = kasNormalizeSocialVisitUrl('facebook', rule.socialUrl, 'https://www.facebook.com/KasAustralia/');
            } else if (rule.templateName === 'dynamiclink' && rule.socialUrl) {
                if ((rule.customTitle || '').toLowerCase().indexOf('pinterest') !== -1) {
                    socialPlatform = 'pinterest';
                    socialUrl = rule.socialUrl;
                }
            }

            var hoverLoggedIn = '';
            if (rule.templateName === 'signup' && isLoggedIn) {
                hoverLoggedIn = '<div class="logged-in-view">✓ Completed</div>';
            } else if (rule.templateName === 'birthday' && isLoggedIn) {
                hoverLoggedIn = '<div class="logged-in-view">Thanks! We\'re looking forward to helping you celebrate :)</div>';
            } else if (socialPlatform && socialUrl) {
                var earnText = 'Earn ' + rule.earnValue + ' points when you visit our page';
                if (socialPlatform === 'facebook') earnText = 'Earn ' + rule.earnValue + ' points when you share us on Facebook';
                if (socialPlatform === 'instagram') earnText = 'Earn ' + rule.earnValue + ' points when you follow us on Instagram';
                hoverLoggedIn = '<div class="logged-in-view">' +
                    '<span class="kas-social-default-content">' + escapeHtml(earnText) + '<br><button class="kas-hover-button kas-social-visit-btn" data-platform="' + escapeHtml(socialPlatform) + '" data-social-url="' + escapeHtml(socialUrl) + '">Visit Page</button></span>' +
                    '<span class="kas-social-completed-content" style="display:none;">✓ Completed</span></div>';
            } else if (rule.templateName === 'dynamiclink' && socialUrl && rule.customTitle && rule.customTitle.toLowerCase().indexOf('sms') !== -1) {
                hoverLoggedIn = '<div class="logged-in-view">Earn ' + rule.earnValue + ' points when you sign up for text messages!</div>';
            } else if (rule.templateName === 'placeorder') {
                hoverLoggedIn = '<div class="logged-in-view">Earn ' + rule.earnValue + ' points for every $1 you spend in our store</div>';
            } else if (rule.templateName === 'reviewsio') {
                var msg = 'Earn ' + rule.earnValue + ' points. Look out for your Review Request email!';
                if ((rule.integrationEventName || '').indexOf('ugc') !== -1) {
                    msg = 'Add a photo or video to your review and earn ' + rule.earnValue + ' points. Look out for your Review Request email!';
                }
                hoverLoggedIn = '<div class="logged-in-view">' + escapeHtml(msg) + '</div>';
            } else {
                hoverLoggedIn = '<div class="logged-in-view">' + escapeHtml(rule.title || '') + '</div>';
            }

            var hoverLoggedOut = '<div class="logged-out-view">' +
                '<button class="kas-hover-button" onclick="window.location.href=\'/account/register\'">Sign Up</button>' +
                '</div>';

            var hoverContent = isLoggedIn ? hoverLoggedIn : hoverLoggedOut;

            var tileAttr = socialPlatform ? ' data-social-tile="' + escapeHtml(socialPlatform) + '"' : '';
            var wrapperClass = 'kas-rewards-tile-wrapper';
            if (rule.templateName === 'signup' && isLoggedIn) {
                wrapperClass += ' kas-rewards-tile-wrapper-completed';
            }
            var innerTileClass = 'kas-rewards-tile';
            if (rule.templateName === 'signup' && isLoggedIn) {
                innerTileClass += ' kas-rewards-tile-completed';
            }

            var html = '<div role="listitem" tabindex="0" class="flexified-child kas-rewards-outer-tile"' + tileAttr + '>' +
                '<div aria-label="For further actions, press enter or alt + enter." class="kas-rewards-campaign-switcher-wrapper">' +
                '<div class="' + wrapperClass + '">' +
                '<div class="' + innerTileClass + '">' +
                '<div class="kas-rewards-widget-campaign-widget-icon-container">' +
                '<img alt="icon" src="' + escapeHtml(iconUrl) + '" class="kas-rewards-widget-campaign-widget-custom-icon">' +
                '</div>' +
                '<div class="kas-rewards-headline-center-element">' +
                '<div class="kas-rewards-title-text">' + escapeHtml(pointsLabel) + '</div>' +
                '</div>' +
                '<div class="kas-rewards-description-text">' + escapeHtml(description) + '</div>' +
                '<div class="kas-rewards-hover-content">' + hoverContent + '</div>' +
                '</div></div></div></div>';

            if (earnGrid) {
                earnGrid.insertAdjacentHTML('beforeend', html);
            }
        });

        if (earnGrid && typeof window.initSocialTracking === 'function') {
            setTimeout(window.initSocialTracking, 100);
        }
    }

    function displayFallbackRules() {
        const earnGrid = document.querySelector('.earn-grid');
        if (!window.__kasEarnRules) {
            window.__kasEarnRules = [
                {
                    templateName: 'placeorder',
                    status: 'Active',
                    earnType: 'increments',
                    earnValue: 1,
                    loyaltyTierIds: []
                }
            ];
            if (typeof updateProductPoints === 'function') {
                document.querySelectorAll('.swell-product-helper[data-mode="display-points"]').forEach(function (helper) {
                    updateProductPoints(helper);
                });
            }
            if (typeof updateCartDrawerEarnPoints === 'function') {
                updateCartDrawerEarnPoints();
            }
        }
        if (!earnGrid) {
            return;
        }
    }

    // Fetch redeem rules from Influence.io public API
    async function fetchRedeemRules() {
        try {
            const API_URL = `https://launcher.api.influence.io/launcher/v1/shop/rules/redeem?shop=${SHOP_DOMAIN}`;

            const response = await fetch(API_URL, {
                method: 'GET',
                headers: { 'Accept': 'application/json' }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            window.__kasRedeemRules = data.rules;
            displayRedeemRules(data.rules);
            displayAmountDiscountTiles(data.rules);
            const redeemList = document.querySelector('[data-kas-redeem-list]');
            if(redeemList){ 
                renderRedeemList(redeemList, data.rules);
                
                // If points are already loaded, re-render the list to update availability
                if (window.customer?.pointBalance !== null && window.customer?.pointBalance !== undefined) {
                    // Small delay to ensure DOM is ready
                    setTimeout(() => {
                        renderRedeemList(redeemList, data.rules);
                    }, 100);
                }
            }
        } catch (error) {
            // Error fetching redeem rules - non-critical
            displayFallbackRedeemRules();
        }
    }

    function displayRedeemRules(rules) {
        const redeemGrid = document.getElementById('redeem-rules-grid');
        if (!redeemGrid) return;

        redeemGrid.innerHTML = '';
        rules.sort((a, b) => a.pointCost - b.pointCost);

        const rulesToDisplay = rules.slice(0, 5);
        rulesToDisplay.forEach(rule => {
            if (rule.status === 'Active') {
                const card = document.createElement('div');
                card.className = 'discount-card';
                const discountAmount = `$${rule.discountValue} OFF`;
                const pointsCost = rule.pointCost / 100;
                const pointsRequired = `${pointsCost.toLocaleString()} POINTS`;
                card.innerHTML = `
                    <span class="discount-amount">${discountAmount}</span>
                    <span class="points-required">${pointsRequired}</span>
                `;
                redeemGrid.appendChild(card);
            }
        });

        const currentCards = redeemGrid.children.length;
        if (currentCards < 5) {
            const defaultValues = [
                { discount: 10, points: 100 },
                { discount: 20, points: 200 },
                { discount: 30, points: 300 },
                { discount: 40, points: 400 },
                { discount: 50, points: 500 }
            ];
            for (let i = currentCards; i < 5; i++) {
                const card = document.createElement('div');
                card.className = 'discount-card';
                card.innerHTML = `
                    <span class="discount-amount">$${defaultValues[i].discount} OFF</span>
                    <span class="points-required">${defaultValues[i].points} POINTS</span>
                `;
                redeemGrid.appendChild(card);
            }
        }
    }

    // Populate "How to use your points" discount tiles from Influence.io redeem rules:
    // templateName amountdiscount, status Active, sorted by discountValue ascending.
    function displayAmountDiscountTiles(rules) {
        var grid = document.getElementById('kas-discount-grid');
        if (!grid) return;

        var amountDiscount = (rules || []).filter(function(r) {
            return r.templateName === 'amountdiscount' && r.status === 'Active';
        });
        amountDiscount.sort(function(a, b) {
            return (a.discountValue || 0) - (b.discountValue || 0);
        });

        if (amountDiscount.length === 0) {
            amountDiscount = [
                { discountValue: 10, pointCost: 100 },
                { discountValue: 20, pointCost: 200 },
                { discountValue: 30, pointCost: 300 },
                { discountValue: 40, pointCost: 400 },
                { discountValue: 50, pointCost: 500 }
            ];
        }

        grid.innerHTML = '';
        amountDiscount.forEach(function(rule) {
            var card = document.createElement('div');
            card.className = 'kas-discount-card';
            card.innerHTML =
                '<span class="kas-discount-amount">$' + rule.discountValue + ' OFF</span>' +
                '<span class="kas-points-required">' + (rule.pointCost || 0) + ' POINTS</span>';
            grid.appendChild(card);
        });
    }

    // Tier card icon/colour mapping for Style Society Tiers (matches existing CDN assets)
    var KAS_TIER_STYLES = {
        'Member': { bg: '#F5EDE3', icon: 'member.svg?v=1777561923' },
        'VIP': { bg: '#F4D5C8', icon: 'diamond.svg?v=1777561923' },
        'Elite': { bg: '#EEB194', icon: 'crown.svg?v=1777561923' },
        'Decor Lover': { bg: '#F5EDE3', icon: 'image_2022_08_29_08_46_37_125.png?v=1759221012' },
        'Style Specialist': { bg: '#F4D5C8', icon: 'image_2022_09_22_02_20_01_680.png?v=1759221042' },
        'Master Designer': { bg: '#EEB194', icon: 'image_2022_08_29_08_48_21_149.png?v=1759221074' }
    };
    var KAS_TIER_ICON_BASE = 'https://cdn.shopify.com/s/files/1/0993/1130/files/';

    // Populate "The Style Society Tiers" section from Influence.io shop/tiers API (ascending by threshold).
    function displayStyleSocietyTiers(tiers) {
        var grid = document.getElementById('kas-tiers-grid');
        if (!grid) return;

        var list = (tiers || []).slice();
        list.sort(function(a, b) {
            return (a.threshold || 0) - (b.threshold || 0);
        });

        grid.innerHTML = '';
        list.forEach(function(tier) {
            var style = KAS_TIER_STYLES[tier.title] || { bg: '#F5EDE3', icon: KAS_TIER_STYLES['Decor Lover'].icon };
            var iconUrl = KAS_TIER_ICON_BASE + style.icon;
            var title = tier.title || '';
            var threshold = tier.threshold != null ? tier.threshold : 0;
            var perks = tier.perks || [];
            var perksHtml = perks.map(function(perk) {
                return '<li>' + (perk || '').replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</li>';
            }).join('');

            var card = document.createElement('div');
            card.className = 'kas-rewards-tier-card-custom';
            card.setAttribute('data-tier-name', title);
            card.innerHTML =
                '<div class="kas-rewards-tier-icon-circle" style="background-color: ' + style.bg + '">' +
                '<img src="' + iconUrl + '" alt="' + title.replace(/"/g, '&quot;') + '" class="kas-rewards-tier-icon-img">' +
                '</div>' +
                '<h3 class="kas-rewards-tier-name">' + title.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</h3>' +
                '<p class="kas-rewards-tier-spend">Spend $' + threshold + '</p>' +
                '<ul class="kas-rewards-tier-benefits-list">' + perksHtml + '</ul>';
            grid.appendChild(card);
        });
    }

    // Fetch loyalty tiers from Influence.io public API
    async function fetchLoyaltyTiers() {
        try {
            const url = `https://launcher.api.influence.io/launcher/v1/shop/tiers?shop=${SHOP_DOMAIN}`;
            const options = { method: 'GET', headers: { accept: 'application/json' } };
            const response = await fetch(url, options);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            // Store tiers globally for lookup
            window.__kasLoyaltyTiers = data.rules;
            displayStyleSocietyTiers(data.rules);
            displayLoyaltyTiers(data.rules);
        } catch (error) {
            // Error fetching loyalty tiers - non-critical
            displayFallbackTiers();
        }
    }

    function displayLoyaltyTiers(tiers) {
        const tiersGrid = document.querySelector('.tiers-grid');
        if (!tiersGrid) return;
        tiersGrid.innerHTML = '';
        var list = (tiers || []).slice();
        list.sort(function(a, b) { return (a.threshold || 0) - (b.threshold || 0); });
        const tierIcons = { 'Member': '🏠', 'VIP': '✨', 'Elite': '👑', 'Decor Lover': '🏠', 'Style Specialist': '✨', 'Master Designer': '👑' };
        list.forEach((tier, index) => {
            const card = document.createElement('div');
            card.className = 'tier-card';
            if (index === 1 && list.length === 3) { card.className += ' featured'; }
            const icon = tierIcons[tier.title] || '🎯';
            let pointsRange = '';
            if (tier.threshold === 0) {
                const nextTier = list[index + 1];
                pointsRange = nextTier ? `0-${nextTier.threshold - 1} points` : '0+ points';
            } else {
                const nextTier = list[index + 1];
                pointsRange = nextTier ? `${tier.threshold}-${nextTier.threshold - 1} points` : `${tier.threshold}+ points`;
            }
            const benefitsHTML = (tier.perks || []).map(perk => `<li>${perk}</li>`).join('');
            card.innerHTML = `
                <div class="tier-icon">${icon}</div>
                <h3>${tier.title}</h3>
                <p class="tier-range">${pointsRange}</p>
                <ul class="tier-benefits">${benefitsHTML}</ul>
            `;
            tiersGrid.appendChild(card);
        });
    }

    function displayFallbackTiers() {
        var grid = document.getElementById('kas-tiers-grid');
        if (!grid) return;
        var fallback = [
            { title: 'Member', threshold: 0, perks: ['Join free', '1 point / $1', 'Early sales', 'Birthday reward'] },
            { title: 'VIP', threshold: 220, perks: ['Spend $250', '1.25 points / $1', 'VIP offers', 'Early collections', 'Members-only deal'] },
            { title: 'Elite', threshold: 450, perks: ['Spend $400', '1.5 points / $1', 'Free Express Shipping', 'Double points events', 'Early product access'] }
        ];
        displayStyleSocietyTiers(fallback);
    }


    // CTA Button interactions
    const ctaButtons = document.querySelectorAll('.cta-button');
    ctaButtons.forEach(button => {
        button.addEventListener('click', function() {
            alert('Redirecting to KAS Rewards signup...');
            if (typeof gtag !== 'undefined') {
                gtag('event', 'click', {
                    'event_category': 'rewards',
                    'event_label': 'join_rewards_program'
                });
            }
        });
    });

    // Add animation on scroll (Intersection Observer)
    const observerOptions = { threshold: 0.1, rootMargin: '0px 0px -50px 0px' };
    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
            }
        });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('.step, .benefit-card, .tier-card');
    animatedElements.forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
        el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(el);
    });

    const gridContainers = document.querySelectorAll('.steps-grid, .benefits-grid, .tiers-grid');
    gridContainers.forEach(container => {
        const items = container.children;
        Array.from(items).forEach((item, index) => {
            item.style.transitionDelay = `${index * 0.1}s`;
        });
    });

    const tierCards = document.querySelectorAll('.tier-card');
    tierCards.forEach(card => {
        card.addEventListener('mouseenter', function() {
            this.style.transform = 'translateY(-10px) scale(1.02)';
        });
        card.addEventListener('mouseleave', function() {
            this.style.transform = 'translateY(0) scale(1)';
        });
    });

    // Mobile menu toggle (if needed for Shopify integration)
    function toggleMobileMenu() {
        const mobileMenu = document.querySelector('.mobile-menu');
        if (mobileMenu) {
            mobileMenu.classList.toggle('open');
        }
    }

    function trackSectionView(sectionName) {
        if (typeof gtag !== 'undefined') {
            gtag('event', 'page_view', {
                'event_category': 'rewards_page',
                'event_label': sectionName
            });
        }
    }

    const sections = document.querySelectorAll('section');
    const sectionObserver = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const sectionClass = entry.target.className;
                trackSectionView(sectionClass);
            }
        });
    }, { threshold: 0.5 });

    sections.forEach(section => {
        sectionObserver.observe(section);
    });

    // Initialize and display customer tier status
    async function initCustomerTierStatus() {
        const isLoggedIn = Boolean(window.customer && window.customer.id);
        if (!isLoggedIn) return;

        try {
            // Wait for both loyalty details and tiers to be available
            const loyaltyDetails = await fetchCustomerLoyaltyDetails();
            
            if (!loyaltyDetails) {
                // Loyalty details endpoint not available, using default tier display
                return;
            }

            // Wait for tiers to be loaded (with timeout)
            let attempts = 0;
            while (!window.__kasLoyaltyTiers && attempts < 50) {
                await new Promise(resolve => setTimeout(resolve, 100));
                attempts++;
            }

            if (!window.__kasLoyaltyTiers) {
                // Tiers not loaded, skipping tier status update
                return;
            }

            updateTierStatusUI(loyaltyDetails, window.__kasLoyaltyTiers);
        } catch (error) {
            // Error initializing tier status (non-critical)
        }
    }

    // Update tier status UI with customer data
    function updateTierStatusUI(loyaltyDetails, tiers) {
        const currentTierNameEl = document.querySelector('[data-kas-current-tier-name]');
        const nextTierNameEl = document.querySelector('[data-kas-next-tier-name]');
        const nextTierThresholdEl = document.querySelector('[data-kas-next-tier-threshold]');
        const currentSpendEl = document.querySelector('[data-kas-current-spend]');
        const nextTierSpendEl = document.querySelector('[data-kas-next-tier-spend]');
        const progressFillEl = document.querySelector('[data-kas-tier-progress-fill]');
        const progressMarkerEl = document.querySelector('[data-kas-tier-progress-marker]');

        // Get current tier name
        const currentTierName = loyaltyDetails.currentLoyaltyTierName || 'Decor Lover';
        
        // Find current tier in tiers array
        const sortedTiers = tiers.sort((a, b) => a.threshold - b.threshold);
        const currentTierIndex = sortedTiers.findIndex(t => t.id === loyaltyDetails.currentLoyaltyTierId);
        const currentTier = sortedTiers[currentTierIndex];
        const nextTier = sortedTiers[currentTierIndex + 1];

        // Update current tier name
        if (currentTierNameEl) {
            currentTierNameEl.textContent = currentTierName;
        }

        // Highlight the current tier card
        const allTierCards = document.querySelectorAll('[data-tier-name]');
        allTierCards.forEach(card => {
            card.classList.remove('current-tier');
            if (card.getAttribute('data-tier-name') === currentTierName) {
                card.classList.add('current-tier');
            }
        });

        // Update next tier information if there is one
        if (nextTier) {
            if (nextTierNameEl) {
                nextTierNameEl.textContent = nextTier.title;
            }

            // Calculate spending needed
            const currentSpend = loyaltyDetails.currentLoyaltyTierProgress || 0;
            const nextTierThreshold = nextTier.threshold || 0;
            const spendNeeded = Math.max(0, nextTierThreshold - currentSpend);

            if (nextTierThresholdEl) {
                nextTierThresholdEl.textContent = `$${spendNeeded}`;
            }

            if (currentSpendEl) {
                currentSpendEl.textContent = `$${currentSpend} Spent`;
            }

            if (nextTierSpendEl) {
                nextTierSpendEl.textContent = `Spend $${nextTierThreshold}`;
            }

            // Update progress bar
            const progressPercent = nextTierThreshold > 0 
                ? Math.min(100, (currentSpend / nextTierThreshold) * 100) 
                : 0;

            if (progressFillEl) {
                progressFillEl.style.width = `${progressPercent}%`;
            }

            if (progressMarkerEl) {
                progressMarkerEl.style.left = `${progressPercent}%`;
            }
        } else {
            // Max tier reached
            if (nextTierNameEl) {
                nextTierNameEl.textContent = 'Max Tier';
            }
            if (nextTierThresholdEl && nextTierThresholdEl.parentElement) {
                nextTierThresholdEl.parentElement.textContent = 'You have reached the highest tier!';
            }
        }
    }

    // Initialize product points display
    function initProductPointsDisplay() {
        const productHelpers = document.querySelectorAll('.swell-product-helper[data-mode="display-points"]');
        
        if (productHelpers.length === 0) {
            return;
        }
        
        productHelpers.forEach(function(helper) {
            updateProductPoints(helper);
        });
    }

    // Call initProductPointsDisplay immediately
    initProductPointsDisplay();

    function initAccountSidebarTierName() {
        const elements = document.querySelectorAll('[data-kas-account-tier-name]');
        if (elements.length === 0) return;
        if (!window.customer || !window.customer.id) return;
        if (typeof fetchCustomerLoyaltyDetails !== 'function') return;

        async function run() {
            let i = 0;
            while (!window.__kasLoyaltyTiers && i < 50) {
                await new Promise(function(resolve) {
                    setTimeout(resolve, 100);
                });
                i++;
            }
            try {
                const details = await fetchCustomerLoyaltyDetails();
                if (!details) return;
                let name = details.currentLoyaltyTierName;
                if (!name && details.currentLoyaltyTierId && typeof getLoyaltyTierName === 'function') {
                    name = getLoyaltyTierName(details.currentLoyaltyTierId);
                }
                if (name) {
                elements.forEach(el => {
                        el.textContent = name;
                        const classFriendlyName = name.toLowerCase().replace(/\s+/g, '-');

                        const container = el.closest('.kas-club-account__tier');
                        if (container) {
                            const iconEl = container.querySelector('.kas-club-account__tier-icon');
                            if (iconEl) {
                                iconEl.classList.add(classFriendlyName);
                            }
                        }
                    });
                }
            } catch (e) {}
        }

        run();
    }

    initAccountSidebarTierName();

});

// Update redeem progress in the drawer widget (global function)
function updateRedeemProgress(redeemRules) {
    
    // Get current user points
    const currentPoints = window.customer?.pointBalance || null;
    
    // Filter active fixed amount discounts
    const activeFixedDiscounts = redeemRules.filter(rule => 
        rule.status === 'Active' && 
        rule.templateName === 'amountdiscount' && 
        rule.redeemType === 'fixed'
    );
    
    
    // Handle null points
    if (currentPoints === null) {
        const progressText = document.querySelector('[data-kas-rewards-missing]');
        if (progressText) {
            progressText.textContent = 'Points unavailable';
        }
        return;
    }
    
    // Find the nearest discount the user can't afford yet
    const affordableDiscounts = activeFixedDiscounts.filter(rule => 
        currentPoints >= rule.pointCost
    );
    
    const unaffordableDiscounts = activeFixedDiscounts.filter(rule => 
        currentPoints < rule.pointCost
    );
    
    
    let targetDiscount = null;
    let pointsNeeded = 0;
    
    if (unaffordableDiscounts.length > 0) {
        // Find the cheapest unaffordable discount
        targetDiscount = unaffordableDiscounts.reduce((cheapest, current) => 
            current.pointCost < cheapest.pointCost ? current : cheapest
        );
        pointsNeeded = targetDiscount.pointCost - currentPoints;
    } else if (affordableDiscounts.length > 0) {
        // User can afford at least one discount, find the most expensive one they can't afford
        const sortedUnaffordable = activeFixedDiscounts
            .filter(rule => currentPoints < rule.pointCost)
            .sort((a, b) => a.pointCost - b.pointCost);
        
        if (sortedUnaffordable.length > 0) {
            targetDiscount = sortedUnaffordable[0];
            pointsNeeded = targetDiscount.pointCost - currentPoints;
        }
    }
    
    
    // Update the drawer widget text
    const progressText = document.querySelector('[data-kas-rewards-missing]');
    if (progressText && targetDiscount) {
        progressText.textContent = `⚡ You're ${pointsNeeded} points away from ${targetDiscount.title}!`;
    } else if (progressText) {
        // Fallback if no target discount found
        progressText.textContent = 'You have enough points for rewards!';
    }
}

// Calculate points earned for a given price (global function)
function calculatePointsForPrice(priceCents) {
    if (!window.__kasEarnRules) {
        console.warn('Earning rules not loaded yet');
        return 0;
    }

    const customerTierId = window.customer?.currentLoyaltyTierId;

    function tierIdsIncludeTier(loyaltyTierIds, tierId) {
        if (!loyaltyTierIds || loyaltyTierIds.length === 0) return false;
        if (tierId == null || tierId === '') return false;
        var t = String(tierId);
        return loyaltyTierIds.some(function (id) {
            return String(id) === t;
        });
    }

    // Tier-specific placeorder rule (IDs from API may be number or string)
    let placeorderRule = window.__kasEarnRules.find(function (rule) {
        return (
            rule.templateName === 'placeorder' &&
            rule.status === 'Active' &&
            tierIdsIncludeTier(rule.loyaltyTierIds, customerTierId)
        );
    });

    // Rules that apply to all tiers (no tier restriction)
    if (!placeorderRule) {
        placeorderRule = window.__kasEarnRules.find(function (rule) {
            return (
                rule.templateName === 'placeorder' &&
                rule.status === 'Active' &&
                (!rule.loyaltyTierIds || rule.loyaltyTierIds.length === 0)
            );
        });
    }

    // Guests or unknown tier: use any active placeorder rule (e.g. only tier-scoped rules in API)
    if (!placeorderRule) {
        placeorderRule = window.__kasEarnRules.find(function (rule) {
            return rule.templateName === 'placeorder' && rule.status === 'Active';
        });
    }

    if (!placeorderRule) {
        console.warn('No active placeorder rule found');
        return 0;
    }

    const priceDollars = priceCents / 100;
    var ev = parseFloat(placeorderRule.earnValue);
    if (!(ev > 0)) {
        return 0;
    }

    // Influence "increments" / tile copy: earnValue points per $1 spent
    var et = (placeorderRule.earnType || '').toLowerCase();
    var isPerDollar = et === 'increments' || et === 'increment';
    var points = isPerDollar
        ? Math.floor(priceDollars * ev)
        : Math.floor(priceDollars / ev);
    return points;
}

// Cart drawer / cart summary: points for current subtotal (same placeorder rule as product PDP)
function updateCartDrawerEarnPoints() {
    document.querySelectorAll('[data-kas-cart-earn-row]').forEach(function(row) {
        const holder = row.closest('[data-cart-price-holder]');
        const scope = holder || row.closest('cart-element') || document;
        const totalEl = scope.querySelector('[data-cart-total]');
        const labelEl = row.querySelector('[data-kas-cart-earn-label]');
        const tpl = row.getAttribute('data-earn-label') || 'Earn __COUNT__ points';

        if (!totalEl || !labelEl) {
            return;
        }

        const raw = totalEl.getAttribute('data-cart-total');
        const subtotal = parseInt(raw, 10);
        if (isNaN(subtotal) || subtotal <= 0) {
            row.hidden = true;
            labelEl.textContent = '';
            return;
        }

        if (!window.__kasEarnRules) {
            row.hidden = true;
            labelEl.textContent = '';
            var n = parseInt(row.getAttribute('data-kas-earn-retry'), 10) || 0;
            if (n < 30) {
                row.setAttribute('data-kas-earn-retry', String(n + 1));
                setTimeout(function() {
                    updateCartDrawerEarnPoints();
                }, 400);
            }
            return;
        }

        row.removeAttribute('data-kas-earn-retry');
        var points = calculatePointsForPrice(subtotal);
        if (!points || points <= 0) {
            row.hidden = true;
            labelEl.textContent = '';
            return;
        }

        row.hidden = false;
        labelEl.textContent = tpl.replace(/__COUNT__/g, String(points));
    });
}

(function bindCartEarnPointsEvents() {
    if (window.__KAS_CART_EARN_EVENTS_BOUND) {
        return;
    }
    window.__KAS_CART_EARN_EVENTS_BOUND = true;
    ['theme:cart:loaded', 'theme:cart:open', 'theme:cart:update', 'theme:cart:added'].forEach(function(evtName) {
        document.addEventListener(evtName, function() {
            requestAnimationFrame(function() {
                if (typeof updateCartDrawerEarnPoints === 'function') {
                    updateCartDrawerEarnPoints();
                }
            });
        });
    });
})();

// Update individual product points display (global function)
function updateProductPoints(helper) {
    const priceCents = parseInt(helper.getAttribute('data-price-cents'));
    
    const pointsEarned = calculatePointsForPrice(priceCents);
    
    if (pointsEarned > 0) {
        helper.textContent = pointsEarned + ' points';
        helper.setAttribute('data-points-earned', pointsEarned);
    } else {
        // If earning rules not loaded yet, set up retry mechanism
        let retryCount = 0;
        const maxRetries = 10;
        const retryInterval = 1000; // 1 second
        
        const retryFunction = function() {
            retryCount++;
            const retryPoints = calculatePointsForPrice(priceCents);
            
            if (retryPoints > 0) {
                helper.textContent = retryPoints + ' points';
                helper.setAttribute('data-points-earned', retryPoints);
            } else if (retryCount < maxRetries) {
                setTimeout(retryFunction, retryInterval);
            } else {
                // Fallback: show default message
                helper.textContent = 'points';
            }
        };
        
        setTimeout(retryFunction, retryInterval);
    }
}
function initRewardsBanner(){
    const banner = document.querySelector('[data-kas-rewards-banner]');
    const drawer = document.querySelector('[data-kas-rewards-drawer]');
    const closeBtn = document.querySelector('[data-kas-rewards-close]');
    const loggedInWrap = document.querySelector('[data-kas-rewards-logged-in]');
    const loggedOutWrap = document.querySelector('[data-kas-rewards-logged-out]');
    const bannerMsg = document.querySelector('[data-kas-rewards-banner-msg]');
    const bannerPointsBlock = document.querySelector('[data-kas-rewards-banner-points]');
    const pointsApiUrl = LOYALTY_ENDPOINT;
    
    
    if(!banner || !drawer) {
        return;
    }

    const pointsEls = {
        banner: document.querySelector('[data-kas-rewards-points-banner]'),
        drawer: document.querySelector('[data-kas-rewards-points]'),
        missing: document.querySelector('[data-kas-rewards-missing]')
    };

    // Update points from customer object if available
    function updatePointsUI(points){
        const pointsValue = points === null || points === undefined ? null : Number(points);
        
        
        // Update customer object with current points
        if (window.customer) {
            window.customer.pointBalance = pointsValue;
        }
        
        // Update banner display
        if(pointsEls.banner) {
            const displayValue = pointsValue === null ? '-' : pointsValue;
            pointsEls.banner.textContent = displayValue;
        }
        
        // Update drawer display
        if(pointsEls.drawer) {
            const displayValue = pointsValue === null ? '-' : pointsValue;
            pointsEls.drawer.textContent = displayValue;
        }
        
        // Update account page points display (same selector as drawer, but ensure it's updated)
        const accountPointsEl = document.querySelector('[data-kas-rewards-points]');
        if(accountPointsEl) {
            const displayValue = pointsValue === null ? '0' : pointsValue;
            accountPointsEl.textContent = displayValue;
        }
        
        // Update progress message
        if(pointsEls.missing){
            // This will be updated by updateRedeemProgress when redeem rules are loaded
            pointsEls.missing.textContent = '';
        }
        
        // Also update swell point balance elements
        const swellPointBalances = document.querySelectorAll('.swell-point-balance');
        swellPointBalances.forEach(function(element) {
            if (pointsValue === null) {
                element.textContent = '-';
            } else {
                element.textContent = pointsValue + ' points';
            }
        });
        
        // Trigger redeem progress update if redeem rules are available
        if (window.__kasRedeemRules) {
            updateRedeemProgress(window.__kasRedeemRules);
            
            // Also re-render the redeem list with updated points
            const redeemListContainer = document.querySelector('[data-kas-redeem-list]');
            if (redeemListContainer) {
                renderRedeemList(redeemListContainer, window.__kasRedeemRules);
            }
        } else {
        }
    }

    // Example: read from a metafield or placeholder; using null when unknown
    const isLoggedIn = Boolean(window.customer && window.customer.id);
    let currentPoints = null;

    // Fetch points from DataJet API (same as account.js)
    async function fetchUserPoints(retryCount = 0) {
        const maxRetries = 2;
        const retryDelay = 2000;
        
        
        if (!isLoggedIn || !LOYALTY_ENDPOINT || !window.customer?.email || !window.customer?.id) {
            return null;
        }
        
        try {
            
            // Use direct API call (after CORS headers are added to data.kasaustralia.com.au)
            const apiUrl = `${LOYALTY_ENDPOINT}?email=${encodeURIComponent(window.customer.email)}&customer_id=${encodeURIComponent(window.customer.id)}`;
            
            const response = await fetch(apiUrl, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json'
                }
            });
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
            }
            
            const data = await response.json();
            
            // Extract points from direct API response structure
            if (data && data.pointBalance !== undefined) {
                return data.pointBalance || 0;
            }
            
            return null;
            
        } catch (error) {
            // Error fetching user points from direct API
            
            // Retry logic for network errors
            if (retryCount < maxRetries && (
                error.message.includes('Failed to fetch') || 
                error.message.includes('timeout') ||
                error.message.includes('NetworkError') ||
                error.message.includes('Request timeout') ||
                error.message.includes('HTTP error! status: 0') ||
                error.message.includes('HTTP error! status: 5') ||
                error.message.includes('Network error')
            )) {
                await new Promise(resolve => setTimeout(resolve, retryDelay * (retryCount + 1)));
                return fetchUserPoints(retryCount + 1);
            }
            
            return null;
        }
    }

    // Initialize points and UI
    async function initializePoints() {
        if (isLoggedIn) {
            try {
                currentPoints = await fetchUserPoints();
                
                // Store successful API response for caching
                if (currentPoints !== null && currentPoints > 0) {
                    localStorage.setItem('kas_user_points', currentPoints.toString());
                }
            } catch (error) {
                
                // Try to get points from localStorage as fallback
                const storedPoints = localStorage.getItem('kas_user_points');
                if (storedPoints) {
                    currentPoints = parseInt(storedPoints, 10);
                } else {
                    // If no cached points and API is failing, show dash
                    currentPoints = null;
                    
                    // Show a user-friendly message in the UI
                    const pointsDisplay = document.querySelector('[data-kas-rewards-points]');
                    if (pointsDisplay) {
                        pointsDisplay.textContent = '-';
                    }
                    
                    // Also update the banner points display
                    const bannerPointsDisplay = document.querySelector('[data-kas-rewards-points-banner]');
                    if (bannerPointsDisplay) {
                        bannerPointsDisplay.textContent = '-';
                    }
                }
            }
        } else {
            currentPoints = null;
        }
        updatePointsUI(currentPoints);
    }

    // Wait for customer data to be available
    function waitForCustomerData() {
        return new Promise((resolve) => {
            if (window.customer && window.customer.id && window.customer.email) {
                resolve();
                return;
            }
            
            // Check every 100ms for up to 5 seconds
            let attempts = 0;
            const checkInterval = setInterval(() => {
                attempts++;
                if (window.customer && window.customer.id && window.customer.email) {
                    clearInterval(checkInterval);
                    resolve();
                } else if (attempts > 50) { // 5 seconds
                    clearInterval(checkInterval);
                    resolve();
                }
            }, 100);
        });
    }

    // Switch UI per login state
    
    if(isLoggedIn){
        if(loggedInWrap) loggedInWrap.hidden = false;
        if(loggedOutWrap) loggedOutWrap.hidden = true;
        if(bannerMsg) bannerMsg.hidden = true;
        if(bannerPointsBlock) bannerPointsBlock.hidden = false;
        const nameEl = document.querySelector('[data-kas-rewards-name]');
        if(nameEl && window.customer.firstName){ nameEl.textContent = window.customer.firstName; }
        
        // Wait for customer data then fetch points
        waitForCustomerData().then(() => {
            initializePoints();
        });
    } else {
        if(loggedInWrap) {
            loggedInWrap.hidden = true;
        }
        if(loggedOutWrap) {
            loggedOutWrap.hidden = false;
        }
        if(bannerMsg) {
            bannerMsg.hidden = false;
        }
        if(bannerPointsBlock) {
            bannerPointsBlock.hidden = true;
        }
        
        // Force hide the points block with additional methods
        const pointsBlock = document.querySelector('[data-kas-rewards-banner-points]');
        if (pointsBlock) {
            pointsBlock.style.display = 'none';
            pointsBlock.hidden = true;
        }
        
        // Also ensure the banner message is visible
        const bannerMessage = document.querySelector('[data-kas-rewards-banner-msg]');
        if (bannerMessage) {
            bannerMessage.style.display = 'block';
            bannerMessage.hidden = false;
        }
    }

    // Toggle
    function openDrawer(){
        drawer.setAttribute('aria-hidden','false');
        banner.setAttribute('aria-expanded','true');
        
        // Add open class and force transform with multiple methods
        drawer.classList.add('open');
        drawer.classList.remove('closed');
        drawer.style.transform = 'translateY(0) !important';
        drawer.style.setProperty('transform', 'translateY(0)', 'important');
        
        
        // Force the transform to be correct with multiple attempts
        setTimeout(() => {
            drawer.style.setProperty('transform', 'translateY(0)', 'important');
        }, 50);
        
        setTimeout(() => {
            drawer.style.setProperty('transform', 'translateY(0)', 'important');
        }, 100);
    }
    function closeDrawer(){
        drawer.setAttribute('aria-hidden','true');
        banner.setAttribute('aria-expanded','false');
        
        // Remove open class and reset transform
        drawer.classList.remove('open');
        drawer.classList.add('closed');
        drawer.style.setProperty('transform', 'translateY(100%)', 'important');
    }
    banner.addEventListener('click', function(){
        const expanded = banner.getAttribute('aria-expanded') === 'true';
        expanded ? closeDrawer() : openDrawer();
    });
    if(closeBtn){ 
        closeBtn.addEventListener('click', closeDrawer); 
    } else {
    }

    // Populate redeem list if API already fetched
    const redeemList = document.querySelector('[data-kas-redeem-list]');
    if(redeemList && window.__kasRedeemRules){
        renderRedeemList(redeemList, window.__kasRedeemRules);
    }

    // Manual points refresh function
    async function refreshPointsManually() {
        try {
            const newPoints = await fetchUserPoints();
            if (newPoints > 0) {
                currentPoints = newPoints;
                localStorage.setItem('kas_user_points', newPoints.toString());
                updatePointsUI(currentPoints);
                return true;
            } else {
                return false;
            }
        } catch (error) {
            // Manual refresh failed
            return false;
        }
    }


    // Expose updater so other parts can set points
    window.KASRewards = window.KASRewards || {};
    window.KASRewards.updateBannerPoints = updatePointsUI;
    window.KASRewards.refreshPoints = initializePoints;
    window.KASRewards.refreshPointsManually = refreshPointsManually;
    window.KASRewards.fetchCustomerLoyaltyDetails = fetchCustomerLoyaltyDetails;
    window.KASRewards.getLoyaltyTierName = getLoyaltyTierName;
    window.KASRewards.updatePoints = updatePointsUI;
    window.KASRewards.calculatePointsForPrice = calculatePointsForPrice;
    window.KASRewards.updateRedeemProgress = updateRedeemProgress;
}

// Helper function to get tier name by tier ID
function getLoyaltyTierName(tierId) {
    if (!tierId) return null;
    
    // Check if tiers are loaded
    if (window.__kasLoyaltyTiers && Array.isArray(window.__kasLoyaltyTiers)) {
        const tier = window.__kasLoyaltyTiers.find(t => t.id === tierId);
        return tier ? tier.title : null;
    }
    
    return null;
}

// Fetch customer loyalty details from DataJet API
async function fetchCustomerLoyaltyDetails(retryCount = 0) {
    const maxRetries = 2;
    const retryDelay = 2000;
    
    const isLoggedIn = Boolean(window.customer && window.customer.id);
    
    if (!isLoggedIn || !LOYALTY_DETAILS_ENDPOINT || !window.customer?.email || !window.customer?.id) {
        // Cannot fetch loyalty details: missing customer data or endpoint
        return null;
    }
    
    try {
        // Use direct API call (after CORS headers are added to data.kasaustralia.com.au)
        const apiUrl = `${LOYALTY_DETAILS_ENDPOINT}?email=${encodeURIComponent(window.customer.email)}&customer_id=${encodeURIComponent(window.customer.id)}`;
        
        const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
        }
        
        const data = await response.json();
        
        // Extract customer details from direct API response structure
        if (data && data !== null) {
            // Add the tier name based on currentLoyaltyTierId
            if (data.currentLoyaltyTierId) {
                data.currentLoyaltyTierName = getLoyaltyTierName(data.currentLoyaltyTierId);
            }
            
            // Cache the successful response
            try {
                localStorage.setItem('kas_customer_loyalty_details', JSON.stringify(data));
                localStorage.setItem('kas_customer_loyalty_details_timestamp', Date.now().toString());
            } catch (e) {
                // Could not cache loyalty details
            }
            
            return data;
        }
        
        return null;
        
    } catch (error) {
        // Only log detailed error on first attempt, and only for non-404 errors
        if (retryCount === 0) {
            if (error.message.includes('404')) {
                // Customer details endpoint not found (404). Feature will be disabled.
            } else {
                // Error fetching customer loyalty details from direct API
            }
        }
        
        // Retry logic for network errors (but not 404s)
        if (retryCount < maxRetries && !error.message.includes('404') && (
            error.message.includes('Failed to fetch') || 
            error.message.includes('timeout') ||
            error.message.includes('NetworkError') ||
            error.message.includes('Request timeout') ||
            error.message.includes('HTTP error! status: 0') ||
            error.message.includes('HTTP error! status: 5') ||
            error.message.includes('Network error')
        )) {
            await new Promise(resolve => setTimeout(resolve, retryDelay * (retryCount + 1)));
            return fetchCustomerLoyaltyDetails(retryCount + 1);
        }
        
        // Try to get cached data as fallback
        try {
            const cached = localStorage.getItem('kas_customer_loyalty_details');
            const cacheTimestamp = localStorage.getItem('kas_customer_loyalty_details_timestamp');
            
            if (cached && cacheTimestamp) {
                const age = Date.now() - parseInt(cacheTimestamp, 10);
                // Use cache if less than 1 hour old
                if (age < 3600000) {
                    // Using cached loyalty details as fallback
                    const cachedDetails = JSON.parse(cached);
                    // Try to add tier name if not already present
                    if (cachedDetails.currentLoyaltyTierId && !cachedDetails.currentLoyaltyTierName) {
                        cachedDetails.currentLoyaltyTierName = getLoyaltyTierName(cachedDetails.currentLoyaltyTierId);
                    }
                    return cachedDetails;
                }
            }
        } catch (e) {
            // Could not retrieve cached loyalty details
        }
        
        return null;
    }
}

function renderRedeemList(container, rules){
    container.innerHTML = '';
    
    // Get current user points
    const currentPoints = window.customer?.pointBalance || null;
    
    
    // Sort rules by point cost (lowest to highest) and take first 5
    const sortedRules = rules
      .filter(rule => rule.status === 'Active' && rule.templateName === 'amountdiscount')
      .sort((a, b) => a.pointCost - b.pointCost)
      .slice(0, 5);
    
    
    sortedRules.forEach(rule => {
        const card = document.createElement('div');
        const isRedeemable = currentPoints !== null && currentPoints >= rule.pointCost;
        
        // Add classes based on redeemability
        card.className = isRedeemable ? 'kas-redeem-card redeemable' : 'kas-redeem-card';
        
        // Check if user has enough points for this discount
        const statusText = currentPoints === null ? 'Points unavailable' : (isRedeemable ? 'Redeem Now' : 'Not enough points');
        
        
        card.innerHTML = `
          <div class="kas-redeem-title">$${rule.discountValue} Off</div>
          <div class="kas-redeem-points">${rule.pointCost.toLocaleString()} points</div>
          <div class="kas-redeem-note ${isRedeemable ? 'redeemable' : ''}">${statusText}</div>
        `;
        
        // Add click functionality for redeemable cards
        if (isRedeemable) {
            card.addEventListener('click', function() {
                window.location.href = '/checkout';
            });
        }
        
        container.appendChild(card);
    });
}

// Shopify-specific functions
window.KASRewards = window.KASRewards || {};
Object.assign(window.KASRewards, {
    initializeCustomer: function(customer) {
        if (customer && customer.id) {
            this.updateUIForLoggedInCustomer(customer);
        } else {
            this.updateUIForGuest();
        }
    },
    updateUIForLoggedInCustomer: function(customer) {
        const ctaButtons = document.querySelectorAll('.cta-button');
        ctaButtons.forEach(button => {
            button.textContent = 'View My Rewards';
            button.onclick = function() { window.location.href = '/account'; };
        });
    },
    updateUIForGuest: function() {
        const ctaButtons = document.querySelectorAll('.cta-button');
        ctaButtons.forEach(button => {
            button.onclick = function() { window.location.href = '/account/register'; };
        });
    },
    updatePointsDisplay: function(points) {
        const pointsDisplay = document.querySelector('.points-display');
        if (pointsDisplay) { pointsDisplay.textContent = `${points} points`; }
    },
    // Get customer loyalty details including tier info, referral link, etc.
    getCustomerLoyaltyDetails: async function() {
        if (typeof fetchCustomerLoyaltyDetails === 'function') {
            return await fetchCustomerLoyaltyDetails();
        }
        return null;
    }
});

// Initialize when Shopify customer data is available
document.addEventListener('shopify:section:load', function() {
    if (typeof window.customer !== 'undefined') {
        window.KASRewards.initializeCustomer(window.customer);
    }
});

// Copy referral link function
window.copyReferralLink = function() {
    const urlInput = document.querySelector('.share-url');
    if (urlInput) {
        urlInput.select();
        urlInput.setSelectionRange(0, 99999);
        try {
            document.execCommand('copy');
            const copyBtn = document.querySelector('.copy-btn');
            const originalHTML = copyBtn.innerHTML;
            copyBtn.textContent = 'Copied!';
            setTimeout(() => { copyBtn.innerHTML = originalHTML; }, 2000);
        } catch (err) {
            // Failed to copy text
        }
    }
};

// Share on WhatsApp function
window.shareOnWhatsApp = function() {
    const referralUrl = document.querySelector('.share-url').value;
    const message = `Check out KAS Australia! Get $20 off your first order of $120 or more: ${referralUrl}`;
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
};

// Social Visit Tracking (Pinterest, Facebook, Instagram)
(function() {
    var SOCIAL_ENDPOINT = 'https://kas-cin7-shopify-sync.jackieochan.workers.dev/kas/social.php';
    var CUSTOMER_ENDPOINT = 'https://kas-cin7-shopify-sync.jackieochan.workers.dev/kas/customer.php';

    // Map tile platform names to the API response field names
    var PLATFORM_API_FIELDS = {
        facebook: 'shareFacebook',
        instagram: 'followInstagram',
        pinterest: 'followPinterest'
    };

    function markTileAsCompleted(tile) {
        var wrapper = tile.querySelector('.kas-rewards-tile-wrapper');
        var innerTile = tile.querySelector('.kas-rewards-tile');
        var defaultContent = tile.querySelector('.kas-social-default-content');
        var completedContent = tile.querySelector('.kas-social-completed-content');

        if (wrapper) {
            wrapper.classList.add('kas-rewards-tile-wrapper-completed');
        }
        if (innerTile) {
            innerTile.classList.add('kas-rewards-tile-completed');
        }
        if (defaultContent) {
            defaultContent.style.display = 'none';
        }
        if (completedContent) {
            completedContent.style.display = '';
        }
    }

    function checkCompletionFromAPI(customerData, platform) {
        if (!customerData) return false;
        var field = PLATFORM_API_FIELDS[platform];
        if (field && customerData[field] === true) return true;
        return false;
    }

    function initSocialTracking() {
        if (!kasIsShopifyCustomerLoggedIn()) return;
        if (!window.customer || !window.customer.id || !window.customer.email) return;

        var customerId = window.customer.id;
        var customerEmail = window.customer.email;
        var socialTiles = document.querySelectorAll('[data-social-tile]');
        var completedStatus = {};

        // Fetch customer data from API to check social completion status
        var apiUrl = CUSTOMER_ENDPOINT
            + '?email=' + encodeURIComponent(customerEmail)
            + '&customer_id=' + encodeURIComponent(customerId);

        fetch(apiUrl, {
            method: 'GET',
            headers: { 'Accept': 'application/json' }
        }).then(function(res) {
            if (!res.ok) throw new Error('API error');
            return res.json();
        }).then(function(customerData) {
            // Check each social tile against API data
            socialTiles.forEach(function(tile) {
                var platform = tile.getAttribute('data-social-tile');
                if (checkCompletionFromAPI(customerData, platform)) {
                    completedStatus[platform] = true;
                    markTileAsCompleted(tile);
                }
            });
        }).catch(function() {
            // API unavailable, tiles remain in default state
        });

        // Attach click handlers to Visit Page buttons
        var visitButtons = document.querySelectorAll('.kas-social-visit-btn');
        visitButtons.forEach(function(btn) {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                var platform = btn.getAttribute('data-platform');
                var socialUrl = btn.getAttribute('data-social-url');
                var tile = btn.closest('[data-social-tile]');

                // If already completed, just open the page
                if (completedStatus[platform]) {
                    window.open(socialUrl, '_blank');
                    return;
                }

                // Call social.php to register the action
                var registerUrl = SOCIAL_ENDPOINT
                    + '?email=' + encodeURIComponent(customerEmail)
                    + '&customer_id=' + encodeURIComponent(customerId)
                    + '&platform=' + encodeURIComponent(platform);

                fetch(registerUrl, {
                    method: 'GET',
                    headers: { 'Accept': 'application/json' }
                }).then(function() {
                    completedStatus[platform] = true;
                    if (tile) {
                        markTileAsCompleted(tile);
                    }
                }).catch(function() {
                    // Still mark as completed visually after click
                    completedStatus[platform] = true;
                    if (tile) {
                        markTileAsCompleted(tile);
                    }
                });

                // Open the social page in a new tab immediately
                window.open(socialUrl, '_blank');
            });
        });
    }

    window.initSocialTracking = initSocialTracking;

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            setTimeout(initSocialTracking, 200);
        });
    } else {
        setTimeout(initSocialTracking, 200);
    }
})();
